module.exports = __webpack_public_path__ + "img/homem-andando (4).c3153f8d.png";